import { useQuery } from '@tanstack/react-query';

import { Declarant } from '@e-origin/shared';

import { showErrorToast } from '@hooks/showErrorToast';
import { request } from '@utils';

export const useAdminDeclarant = (id) =>
  useQuery({
    queryKey: ['admin-declarant', id],
    queryFn: async (): Promise<Declarant> => {
      try {
        const { data } = await request({
          path: `declarant/${id}`,
          method: 'GET',
          authenticate: true,
        });
        return data;
      } catch (error) {
        showErrorToast(error, 'Failed to fetch declarant details');
      }
    },
  });
